import React from "react";
import PropTypes from 'prop-types';

var Warning = function Warning(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 10 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 10 : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#C9012F' : _ref$fill;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8H8.5V11H9.5V8Z",
    fill: fill
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13V12H8.5V13H9.5Z",
    fill: fill
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16L9 0L18 16H0ZM9 2.03973L16.2902 15H1.70985L9 2.03973Z",
    fill: fill
  }));
};

Warning.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string
};
export default Warning;